import { post } from "../utils/request";
import router from "../router";
import store from "../store";
import { ROOT_ACCOUNT } from "../utils/utilData";


/**
 * @function POST /login
 * 
 * @description 根据用户名密码判断是否有该用户，如果有则返回用户登录所需要的全部信息
 * @param username {String} 用户名
 * @param password {String} 密码
 * 
 * @returns {String} 用户信息json字符串
 */
export const getUserInfo = (data) => {
  post('/login', data).then((res) => {
    // code=200时才进入此部分
    let resData = JSON.parse(res.data.data);
    store.commit("TOKEN", resData.token);
    store.commit("USER_INFO", resData.userInfo);
    store.commit("DEPARTMENT_INFO", resData.departmentInfo);
    store.commit("ROLE_LIST", resData.roleList);
    store.commit("MENUS", resData.menus);
    store.commit("REGION_INFO", resData.regionInfo);
    sessionStorage.setItem("roleMap", resData.roleMap);
    if (resData.roleList[0].roleId == ROOT_ACCOUNT) {
      router.push("/bureau-manage");
    } else {
      router.push("/index");
    }
    ;
  });
}